import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpHeaders, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { EMPTY, Observable, throwError } from 'rxjs';
import { StorageService } from '../services/storage.service';
import { catchError, map } from 'rxjs/operators';
import { alertaConfirmacionHTML } from '../shared/utils';
import { Router } from '@angular/router';
import { SpinnerService } from '../services/spinner.service';

@Injectable({

  providedIn: 'root'
})
export class InterceptorService implements HttpInterceptor {

  public sessionInfo: any = {};

  constructor(
    private router: Router, private spinnerService: SpinnerService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    this.sessionInfo = JSON.parse(StorageService.getSession());
    let _token: any = (this.sessionInfo != null && this.sessionInfo.token != undefined && this.sessionInfo.token != null && this.sessionInfo.token.length > 5) ? this.sessionInfo.token : ""
    const headers = new HttpHeaders({
      'Authorization': _token
    })
    const reqClone = req.clone({
      headers
    });


    // return next.handle(reqClone).pipe();

    return next.handle(reqClone).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          // console.log('event--->>>', event);
        }
        return event;
      }), catchError((err: HttpErrorResponse) => {

        console.log(" next.handle ==> ");
        console.log(err);
        console.log(err.status);

        let _error: any = err.error;
        if (err.status == 401 && _error.message != undefined) {


          if (_error.status == 0.9) {
            this.showViewLogin();
            return EMPTY;

          } else {
            let _token: string = _error.message.split("=>")[1];
            console.log(_token);
            console.log(_token.trim());
            this.sessionInfo = JSON.parse(StorageService.getSession());
            if (this.sessionInfo != null) {
              console.log("interceptor  :::")
              this.sessionInfo.correo = "jromero";
              this.sessionInfo.token = _token.trim();
              console.log(this.sessionInfo)
              StorageService.setAll(JSON.stringify(this.sessionInfo));
            }

            const headers = new HttpHeaders({
              'Authorization': this.sessionInfo.token || ''
            })
            const reqClone = req.clone({
              headers
            });

            return next.handle(reqClone)
          }
        }
        return throwError(err);
      }));

  }

  showViewLogin() {
    let html = `<div style="font-size: 1.2rem; font-weight: bolder">Ha superado el tiempo límite de inactividad, vuelva a iniciar sesión<div> `;
    this.spinnerService.activarLoading(false);
    alertaConfirmacionHTML(html, 'warning').then((responseAlert2) => {
      if (responseAlert2) {
        StorageService.clearStorage();
        this.router.navigateByUrl(`/login`);
      }
    });
  }

}
